// Renders inline formatting inside a block of text:
//   *italic*   => <em>italic</em>
//   **bold**   => <strong>bold</strong>
//   _italic_   => <em>italic</em>   (alt form, easier on mobile)
//
// Order matters: match **...** BEFORE *...* so bold doesn't get chopped
// into two italics. Escapes plain text automatically because React does it.
import React from "react";

export function renderInline(text) {
  if (!text) return null;
  // Split on **bold**, *italic*, or _italic_ while KEEPING the delimiters
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*|_[^_]+_)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**") && part.length >= 4) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith("*") && part.endsWith("*") && part.length >= 2) {
      return <em key={i}>{part.slice(1, -1)}</em>;
    }
    if (part.startsWith("_") && part.endsWith("_") && part.length >= 2) {
      return <em key={i}>{part.slice(1, -1)}</em>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}
